import jwt from 'jwt-decode';

const userDetails = () => {
    try {
        const token = localStorage.getItem('access_token');
        if (token && token !== '' && token !== 'null' && token !== 'undefined') {
            const decoded = jwt(token);
            if (decoded) {
                if (!decoded.role) {
                    decoded.role = decoded.userRole || decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || localStorage.getItem('userRole');
                }
                return decoded;
            }
        }
    } catch (e) {
        console.error("Error decoding access_token:", e);
    }

    const fallbackRole = localStorage.getItem('userRole');
    if (fallbackRole) {
        return {
            role: fallbackRole,
            userRole: fallbackRole,
            name: localStorage.getItem('Username') || '',
            sub: localStorage.getItem('UserID') || ''
        };
    }

    return null;
}

export default userDetails;

export const getUserRole = () => {
    const role = localStorage.getItem('userRole');
    if(role){
        return role;
    }
    return null;
}



// import jwt from 'jwt-decode';
// import { useHistory } from 'react-router-dom';

// const userDetails = () => {
//     const tokenString = localStorage.getItem('access_token');
//     if (tokenString !== '' && tokenString !== null && tokenString !== undefined) {
//         let expiry = (JSON.parse(atob(tokenString.split('.')[1]))).exp;
//         // console.log((JSON.parse(atob(tokenString.split('.')[1]))).exp);
//         // console.log(Math.floor((new Date).getTime() / 1000));
//         if ((Math.floor((new Date).getTime() / 1000)) >= expiry) {
//             window.location.assign('/');
//         }
//         else {
//             return jwt(localStorage.getItem('access_token'));
//         }
//     }
//     return null;
//     // else {
//     //     return true;
//     // }
// }

// export default userDetails;

// isTokenExpired(): boolean {
//     const tokenString: string = localStorage.getItem('access_token');
//     if (tokenString !== '' && tokenString !== null && tokenString !== 'undefined') {
//       let expiry = (JSON.parse(atob(tokenString.split('.')[1]))).exp;
//       return (Math.floor((new Date).getTime() / 1000)) >= expiry;
//     } else {
//       return true;
//     }
//   }